const preloaded = new Set();

export function preloadImage(src) {
  if (!src || preloaded.has(src)) return;
  preloaded.add(src);

  const img = new Image();
  img.decoding = 'async';
  img.src = src;
}

export function preloadImages(sources = []) {
  sources.forEach(preloadImage);
}

export function preloadImageLink(src, { fetchPriority } = {}) {
  if (!src || typeof document === 'undefined') return;
  const id = `preload-${src}`;
  if (document.getElementById(id)) return;

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'preload';
  link.as = 'image';
  link.href = src;
  if (fetchPriority) {
    link.setAttribute('fetchpriority', fetchPriority);
  }
  document.head.appendChild(link);
}

export function preloadAdjacentImages(sources, index) {
  if (!sources?.length) return;
  const count = sources.length;
  const prev = sources[(index - 1 + count) % count];
  const next = sources[(index + 1) % count];
  preloadImage(prev);
  preloadImage(next);
}
